var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " self";
},"3":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"msg "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.self : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"msg-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-time=\""
    + alias2(alias1((depth0 != null ? depth0.time : depth0), depth0))
    + "\">\n	<span class=\"time tooltipped tooltipped-e\" aria-label=\""
    + alias2(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/localetime.js")).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"localetime","hash":{},"data":data}))
    + "\">\n		"
    + alias2(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/tz.js")).call(alias3,(depth0 != null ? depth0.time : depth0),{"name":"tz","hash":{},"data":data}))
    + "\n	</span>\n	<span class=\"from\"></span>\n	<span class=\"content\"></span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/msg_action.tpl
// module id = 237
// module chunks = 0